/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { ContractRole } from './contractRole.model';


export interface ConcernedSubjectFullDto { 
    contractRole?: ContractRole;
    ico?: string;
    id?: number;
    lpisUserId?: number;
    name?: string;
    opsubId?: number;
    rodneCislo?: string;
    subject?: SubjectContactResponseDto;
}
export namespace ConcernedSubjectFullDto {
}


